//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { TagsContext } from "../context/TagsContext";
import { Tag, Trash2 } from "lucide-react";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerTags() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { tags, setTags } = useContext(TagsContext); // Estado que armazena a lista de Tags
    const { tagSearched, setTagSearched } = useContext(TagsContext);
    const { isOpenModalDeleteTag, setIsOpenModalDeleteTag } = useContext(TagsContext);
    const { formDataModalDeleteTag, setFormDataModalDeleteTag } = useContext(TagsContext); // Estado que armazena se Tag deve ser deletada
    const { itemsPerPage, setItemsPerPage } = useContext(TagsContext); // Estado que armazena a quantidade de Itens por Página
    const { currentPage, setCurrentPage } = useContext(TagsContext); // Estado que armazena qual é a Página Atual que está sendo apresentada



    //---------- CRIAÇÃO DE VARIÁVEIS ---------//
    const tagsFiltred = tags.filter((tag) => // Variável que armazena as Tags Filtradas
        tag.nome.toLowerCase().includes(tagSearched.toLowerCase())
    );
    const paginatedTags = tagsFiltred.slice( // Variável que armanzena o tatal de Tags contidads na página
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM AS TAGS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">

                {/* CONSTRUÇÃO DAS TAGS NA PÁGINA */}
                {paginatedTags.map((tag) => (
                    <div key={tag.id} className="bg-surface-2 border border-white/[0.08] rounded-xl p-4 flex items-center justify-between">

                        <div className="flex items-center gap-3 flex-grow min-w-0">

                            <Tag className="flex-shrink-0 w-6 h-6 text-brand-400" />

                            <div className="min-w-0">
                                <div className="font-semibold text-white truncate">{tag.nome}</div>
                                <div className="text-xs text-ink-3">{tag.total_leads} lead{tag.total_leads !== 1 && 's'}</div>
                            </div>

                        </div>

                        <button className="flex-shrink-0" onClick={() => {
                            setIsOpenModalDeleteTag(true);
                            setFormDataModalDeleteTag({ tag: tag })
                        }}>
                            <Trash2 className="w-5 h-5 text-ink-3 hover:text-red-500" />
                        </button>
                    </div>
                ))}

            </div>

        </>
    )
}